import { render, staticRenderFns } from "./ActivateCondominiumModal.vue?vue&type=template&id=84a3363c&"
import script from "./ActivateCondominiumModal.vue?vue&type=script&lang=js&"
export * from "./ActivateCondominiumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports